import * as React from "react";
import styled from "styled-components";
import {
  Column,
  Columns,
  Heading,
  Hidden,
  Stack,
  Text,
} from "@origin-digital/ods-core";
import { LoginViewMessagesController } from "../LoginViewMessages";
import { BreadcrumbsController } from "../Breadcrumbs";
import { PathnameMap } from "../../interfaces/breadcrumbs";

interface IProps {
  title: string;
  description?: string;
  isNative: boolean;
  hideTitleAndDescription?: boolean;
  hideBreadcrumbs: boolean;
  titleIsHeading?: boolean;
  breadcrumbsMap?: PathnameMap;
  showLoginCard?: boolean;
}

const StyledBreadCrumbsCompact = styled.div`
  .MuiBreadcrumbs-root {
    margin-top: -16px;
    margin-bottom: 16px;
  }
`;

const BannerHeading = ({
  title,
  titleIsHeading,
}: {
  title: string;
  titleIsHeading: boolean;
}) => (
  <Heading
    component={titleIsHeading ? "h1" : "h2"}
    variant="h3"
    data-id="search-banner-title"
  >
    {title}
  </Heading>
);

export const ContentHeader = (props: IProps) =>
  props.hideTitleAndDescription ? (
    <ContentHeaderCompact {...props} />
  ) : (
    <ContentHeaderFull {...props} />
  );

const ContentHeaderFull = ({
  hideBreadcrumbs,
  isNative,
  title,
  description,
  titleIsHeading = true,
  breadcrumbsMap,
  showLoginCard = true,
}: IProps) => (
  <>
    <Stack space="xlarge">
      {!hideBreadcrumbs && (
        <Hidden below="md">
          <BreadcrumbsController pathnameMap={breadcrumbsMap} />
        </Hidden>
      )}
      {showLoginCard ? (
        <Columns collapseBelow="lg" space={["none", "xlarge"]} alignY="top">
          <Column width="1/2">
            <Stack space={["large", "xlarge"]}>
              <Stack space="large">
                <BannerHeading title={title} titleIsHeading={titleIsHeading} />
                {!isNative && (
                  <Text tone="neutral" data-id="description">
                    {description}
                  </Text>
                )}
              </Stack>
            </Stack>
          </Column>
          <LoginCardColumn isNative={isNative} />
        </Columns>
      ) : (
        <Columns collapseBelow="lg" space={["none", "xlarge"]} alignY="top">
          <Column>
            <Stack space={["large", "xlarge"]}>
              <Stack space="large">
                <BannerHeading title={title} titleIsHeading={titleIsHeading} />
                {!isNative && (
                  <Text tone="neutral" data-id="description">
                    {description}
                  </Text>
                )}
              </Stack>
            </Stack>
          </Column>
        </Columns>
      )}
    </Stack>
  </>
);

const ContentHeaderCompact = ({
  hideBreadcrumbs,
  isNative,
  breadcrumbsMap,
  showLoginCard = true,
}: IProps) => (
  <>
    <Stack space="xlarge">
      {showLoginCard ? (
        <Columns collapseBelow="lg" space={["none", "xlarge"]} alignY="top">
          <Column width="1/2">
            <Stack space={["large", "xlarge"]}>
              {!hideBreadcrumbs && (
                <Hidden below="md">
                  <StyledBreadCrumbsCompact>
                    <BreadcrumbsController pathnameMap={breadcrumbsMap} />
                  </StyledBreadCrumbsCompact>
                </Hidden>
              )}
            </Stack>
          </Column>
          <LoginCardColumn isNative={isNative} />
        </Columns>
      ) : (
        <Columns collapseBelow="lg" space={["none", "xlarge"]} alignY="top">
          <Column>
            <Stack space={["large", "xlarge"]}>
              {!hideBreadcrumbs && (
                <Hidden below="md">
                  <StyledBreadCrumbsCompact>
                    <BreadcrumbsController pathnameMap={breadcrumbsMap} />
                  </StyledBreadCrumbsCompact>
                </Hidden>
              )}
            </Stack>
          </Column>
        </Columns>
      )}
    </Stack>
  </>
);

const LoginCardColumn = ({ isNative }: { isNative: boolean }) => (
  <Column width="1/2">
    <Hidden below="lg">
      <Columns collapseBelow="lg" space="xlarge">
        <Column width="1/3">
          <Hidden below="md">&nbsp;</Hidden>
        </Column>
        <Column width="2/3">
          <Hidden below="md">
            {!isNative && (
              <LoginViewMessagesController
                backgroundColor="white"
                data-id="searchBanner-LoginViewMessages"
              />
            )}
          </Hidden>
        </Column>
      </Columns>
    </Hidden>
  </Column>
);
